import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getDefaultRouteForRole } from "@/lib/roles";

const RoleRoute = ({ roles = [], children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!roles.length) {
    return children;
  }

  if (!user || !roles.includes(user.role)) {
    return (
      <Navigate
        to={getDefaultRouteForRole(user?.role)}
        replace
        state={{
          accessDenied: {
            requestedPath: `${location.pathname}${location.search}`,
            requiredRoles: roles,
          },
        }}
      />
    );
  }

  return children;
};

export default RoleRoute;
